module.exports = require('./lib/mnemonic');



//////////////////
// WEBPACK FOOTER
// ./~/bitcore-mnemonic/index.js
// module id = 478
// module chunks = 0